import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BackgroundFormService {
  submitBackgroundForm="/backgroundform/save"
  validateToken="/backgroundform/validate"
  viewBackgroundForm="/backgroundform/view"

  constructor(private http: HttpClient) { }

  validateTokenbackgroundForm(token:any){
    let params = new HttpParams();
    if(token!=null ){
    params = params.append('Token', token);
    }
   
    return this.http.post(`${this.validateToken}`,"",{params:params});

  }
  submitBackgroundFormDetails(details:any){
    return this.http.post(`${this.submitBackgroundForm}`,details);

  }
  viewBackgroundFormDetails(appointmentId:any){
    let params = new HttpParams();
    if(appointmentId!=null ){
    params = params.append('appointmentId', appointmentId);
    }
    return this.http.get<any>(`${this.viewBackgroundForm}`,{params:params});

  }
}
